import type { SearchResults } from 'algoliasearch-helper';

import type { Item } from '@/domains/productDiscovery/Listings/components/Filters/components/MultiSelect/interfaces';
import { URL_MULTIPLE_FILTER_VALUE_SEPARATOR } from '@/productDiscovery/Listings/constants';

import { Ratings } from '../components/Ratings/Ratings';

const getCumulateCountOfFacets = (
  facets: SearchResults.FacetValue[],
  counts: string[],
): number =>
  facets.reduce(
    (count, facet) =>
      counts.includes(facet.name) ? count + facet.count : count,
    0,
  );

const getIsRefinedOfFacets = (
  facets: SearchResults.FacetValue[],
  counts: string[],
): boolean =>
  facets.reduce<boolean>(
    (refined, facet) =>
      counts.includes(facet.name) ? refined && facet.isRefined : refined,
    true,
  );

const fourAndMoreValues = ['4', '4.5', '5'];
const threeAndMoreValues = ['3', '3.5', ...fourAndMoreValues];

export const generateRatingItems = (
  values: SearchResults.FacetValue[] = [],
): Item[] =>
  [
    {
      id: '4&more',
      label: <Ratings value={4} />,
      count: getCumulateCountOfFacets(values, fourAndMoreValues),
      isRefined: getIsRefinedOfFacets(values, fourAndMoreValues),
      value: fourAndMoreValues.join(URL_MULTIPLE_FILTER_VALUE_SEPARATOR),
    },
    {
      id: '3&more',
      label: <Ratings value={3} />,
      count: getCumulateCountOfFacets(values, threeAndMoreValues),
      isRefined: getIsRefinedOfFacets(values, threeAndMoreValues),
      value: threeAndMoreValues.join(URL_MULTIPLE_FILTER_VALUE_SEPARATOR),
    },
  ].filter(({ count }) => count > 0);
